export default __webpack_public_path__ + "static/media/enough.83a87836.jpg";